import { useDemoUpdates } from '@/features/pulseDemo/useDemoContent'
import { usePulseUiStore } from '@/features/pulsePanel/pulseUiStore'
import { useOpenUpdate } from '@/features/pulsePanel/useOpenPulseItem'
import HomeNavScheduleRow from './HomeNavScheduleRow'
import HomeNavSectionToggle from './HomeNavSectionToggle'
import HomeNavUpdateRow from './HomeNavUpdateRow'
import styles from './pulseRail.module.scss'

const RAIL_LIMIT = 8

/** Recent run results, then the schedules themselves, under a foldable header. */
export default function HomeNavUpdatesSection({ workflows, selectedScheduleId, selectedScheduleKind, onSelectWorkflow }) {
  const updates = useDemoUpdates().slice(0, RAIL_LIMIT)
  const open = usePulseUiStore((s) => s.open)
  const openUpdate = useOpenUpdate()
  const unread = updates.filter((update) => !update.read).length
  const badge = unread ? (
    <span className={styles.unreadBadge} aria-label={`${unread} unread`}>
      {unread}
    </span>
  ) : null

  return (
    <HomeNavSectionToggle title="Updates" actions={badge}>
      {updates.map((update) => (
        <HomeNavUpdateRow
          key={update.id}
          update={update}
          active={open?.kind === 'update' && open.id === update.id}
          onSelect={openUpdate}
        />
      ))}
      {workflows.map((workflow) => (
        <HomeNavScheduleRow
          key={workflow.id}
          workflow={workflow}
          active={workflow.id === selectedScheduleId && selectedScheduleKind === 'workflow'}
          onSelect={onSelectWorkflow}
        />
      ))}
    </HomeNavSectionToggle>
  )
}
